<template>
	<th @click="sortClick" :class="classObject">
		{{ !!item.title ? item.title : '' }}
		<span class="sort-icon">
			<font-awesome-icon
				:icon="['fad', 'sort-amount-up']"
				v-if="!!isActive && !!isSortAsc"
			></font-awesome-icon>
			<font-awesome-icon
				:icon="['fad', 'sort-amount-down']"
				v-if="!!isActive && !!isSortDesc"
			></font-awesome-icon>
		</span>
	</th>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => {},
			required: true,
		},
		index: {
			type: Number,
			default: 0,
			required: true,
		},
		orderingEnabled: {
			type: Boolean,
			default: true,
			required: false,
		},
		ordering: {
			type: Array,
			default: () => [],
			required: false,
		},
	},
	computed: {
		classObject: function() {
			return {
				sorting: !!this.isSortable,
				active: !!this.isActive,
			}
		},
		isSortable: function() {
			return !!this.orderingEnabled && !!this.item.orderable
		},
		isActive: function() {
			let active = false

			for (var i = 0; i < this.ordering.length; i++) {
				let element = this.ordering[i]

				if (element.index == this.index) {
					active = true
					break
				}
			}

			return active
		},
		isSortAsc: function() {
			let sort = false

			for (var i = 0; i < this.ordering.length; i++) {
				let element = this.ordering[i]

				if (element.index == this.index && element.sort.toUpperCase() == 'ASC') {
					sort = true
					break
				}
			}

			return sort
		},
		isSortDesc: function() {
			let sort = false

			for (var i = 0; i < this.ordering.length; i++) {
				let element = this.ordering[i]

				if (element.index == this.index && element.sort.toUpperCase() == 'DESC') {
					sort = true
					break
				}
			}

			return sort
		},
	},
	methods: {
		sortClick: function() {
			if (!this.orderingEnabled || !this.item.orderable) return

			this.$parent.sortColumn(this.index)
		},
	},
}
</script>
